export default class PasswordShowHide {
    constructor() {
        let allPassShow = this.getShowButtons();
        let allPassHide = this.getHideButton();

        if (allPassShow.length === 0 || allPassHide.length === 0) {
            // console.warn('No password toggle buttons found - aborting..');
            return;
        }

        allPassShow.forEach(function (showButton) {
            showButton.addEventListener('click', function () {
                let passwordField = showButton.closest('.pass').querySelector('input[type="password"]');
                if (passwordField) {
                    passwordField.type = 'text';
                    showButton.style.display = 'none';
                    showButton.nextElementSibling.style.display = 'block';
                }
                // console.debug('Password shown for:', showButton);
            });
        });

        allPassHide.forEach(function (hideButton) {
            hideButton.addEventListener('click', function () {
                let passwordField = hideButton.closest('.pass').querySelector('input[type="text"]');
                if (passwordField) {
                    passwordField.type = 'password';
                    hideButton.style.display = 'none';
                    hideButton.previousElementSibling.style.display = 'block';
                }
                // console.debug('Password hidden for:', hideButton);
            });
        });
    }

    /**
     * Get all hide password buttons
     * @returns {NodeList}
     */
    getHideButton() { return document.querySelectorAll('.togglePassword-hide') }

    /**
     * Get all show password buttons
     * @returns {NodeList}
     */
    getShowButtons() { return document.querySelectorAll('.togglePassword-show') }
}
